// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m19In","comment":"styles_comment__3z-op"};